import { useEffect } from 'react';
import { useLang } from '../../../../../hooks/use-lang';
import { useModalParams } from '../../../../../hooks/use-modal-params';
import { useQueryParams } from '../../../../../hooks/use-query-params';
import { useAdminsStore } from '../../../../../store/use-admins-store';
import { useManagerStore } from '../../../../../store/use-manager-store';
import { useRoleStore } from '../../../../../store/use-role-store';

export const useRolesAndAccess = () => {
  const { t, getLocale } = useLang();
  const { fetchRoles, putRole, roles, isLoading, deleteRole } = useRoleStore();
  const { addQueryParams } = useQueryParams();
  const { fetchAdmins } = useAdminsStore();
  const { managerProfile } = useManagerStore();

  useEffect(() => {
    fetchRoles({ is_by_company: true, since_id: 0, n: 1000 });
    fetchAdmins({ n: 1000, since_id: 0, with_archive: true });
  }, []);

  const createRoleModal = useModalParams('createRole');

  return {
    roles,
    putRole,
    t,
    getLocale,
    isLoading,
    createRoleModal,
    deleteRole,
    addQueryParams,
    managerProfile,
  };
};
